import {AxiosPromise} from "axios";
import {CONSTANT_CONFIG} from "../../constants";
import { HttpService } from "../../services/http.services";

const RESOURCE_ENDPOINT = `${CONSTANT_CONFIG.CORE_SERVER_PREFIX}/chat-message`
const endpoints = {
    list: () => `${RESOURCE_ENDPOINT}`,
    getById: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    create: () => `${RESOURCE_ENDPOINT}`,
    update: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    updatePartial: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    delete: (id: any) => `${RESOURCE_ENDPOINT}/${id}`,
    countBadge: (userId: any) => `${RESOURCE_ENDPOINT}/count-badge/${userId}`,
    contactSupplier: () => `${RESOURCE_ENDPOINT}/contact-supplier`,
    countMessage: () => `${RESOURCE_ENDPOINT}/count-message`,
    getMessageAnalytics: () => `${RESOURCE_ENDPOINT}/message-analytics`,
}

export default class ChatMessageApi {
    public list = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.list();
        return HttpService.get(url, params, headers);
    }

    public getById = (id: any): AxiosPromise<any> => {
        const url = endpoints.getById(id);
        return HttpService.get(url);
    }

    public create = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.create();
        return HttpService.post(url, payload, params, headers);
    }

    public update = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.update(id);
        return HttpService.put(url, payload, params, headers);
    }

    public updatePartial = (id: any, payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.updatePartial(id);
        return HttpService.patch(url, payload, params, headers);
    }

    public delete = (id: any, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.delete(id);
        return HttpService.delete(url, params, headers);
    }

    public countBadge = (userId: any): AxiosPromise<any> => {
        const url = endpoints.countBadge(userId);
        return HttpService.get(url);
    }

    public contactSupplier = (payload = {}, params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.contactSupplier();
        return HttpService.post(url, payload, params, headers);
    }

    public countMessage = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.countMessage();
        return HttpService.get(url, params, headers);
    }

    public getMessageAnalytics = (params = {}, headers = {}): AxiosPromise<any> => {
        const url = endpoints.getMessageAnalytics();
        return HttpService.get(url, params, headers);
    }
}